import React from 'react';
import {Box, Button, Text, Layout, View, useDevice} from '@lookiero/aurora';
import {useIntl} from '@/modules/I18N';
import {SEO} from '@/modules/SEO';

import {TEXT} from './NotFound.definition';
import {styles} from './NotFound.styles';

const goToHome = () => (window.location.href = '/');

export const NotFound: React.FC = () => {
  const {formatMessage} = useIntl();
  const {screen} = useDevice();

  return (
    <>
      <SEO>
        <title>{formatMessage(TEXT.PAGE_TITLE)}</title>
      </SEO>
      <Layout style={styles.layout}>
        <Box size={{L: '1/3'}}>
          <View style={styles.textContainer}>
            <Text heading as="h2" level={1} style={styles.title}>
              {formatMessage(TEXT.TITLE)}
            </Text>
            <Text as="p" level={3} style={styles.subtitle}>
              {formatMessage(TEXT.SUBTITLE)}
            </Text>
          </View>
          <View style={screen.L && styles.actionsL}>
            <Button onPress={goToHome}>{formatMessage(TEXT.BTN_BACK_HOME)}</Button>
          </View>
        </Box>
      </Layout>
    </>
  );
};
